import React from 'react';
import TimelineItem from '@mui/lab/TimelineItem';
import TimelineSeparator from '@mui/lab/TimelineSeparator';
import TimelineConnector from '@mui/lab/TimelineConnector';
import TimelineContent from '@mui/lab/TimelineContent';
import TimelineDot from '@mui/lab/TimelineDot';
import Icon from '../../../../../muiComponents/Icon';

interface TimelineStepProps {
    children: React.ReactNode;
    iconName: string;
    completed?: boolean;
    active: boolean;
    last?: boolean;
}

const TimelineStep = (props: TimelineStepProps) => {
    const { children, iconName, completed, active, last = false } = props;
    return (
        <TimelineItem
            sx={{
                '&::before': { padding: 0 },
            }}
        >
            <TimelineSeparator>
                <TimelineDot
                    sx={{
                        margin: 0,
                        width: 40,
                        height: 40,
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        zIndex: 1,
                        backgroundColor:
                            active || !completed ? '#CDE4EA' : '#05667b',
                        border: active ? '2px solid #05667b' : 'none',
                        color: active
                            ? '#05667b'
                            : completed
                            ? '#CDE4EA'
                            : '#05667B80',
                    }}
                >
                    <Icon iconName={iconName} />
                </TimelineDot>
                {!last && (
                    <TimelineConnector
                        sx={{
                            margin: 0,
                            backgroundColor: completed ? '#05667b' : '#CDE4EA',
                            width: 5,
                            zIndex: 0,
                        }}
                    />
                )}
            </TimelineSeparator>
            <TimelineContent sx={{ padding: '0 0 20px 20px' }}>
                {children}
            </TimelineContent>
        </TimelineItem>
    );
};

export default TimelineStep;
